module.exports = __webpack_public_path__ + "static/media/bocongthuong1.4e58f890.svg";